<style lang="scss" scoped>
.feed-wrapper {
  background: #f5f5f5;
  .feed-list-wrapper {
    display: flex;

    position: relative;

    min-height: calc(100vh - 1rem);

    flex-direction: column;
    justify-content: space-between;
  }
}
</style>

<template>
  <div ref="feedModule" class="feed-wrapper">
    <feed-tab
      :feed-tab-data="feedTabData"
      @onTabChange="onTabChange"
    ></feed-tab>
    <div class="feed-list-wrapper">
      <feed-list :list="feedList" @onTick="onTick"></feed-list>
      <bottom-loading
        v-if="feedList.length"
        :status="isLastPage ? 'isLastPage' : 'isLoading'"
      ></bottom-loading>
    </div>
  </div>
</template>
<script>
import { API } from '@/api'

import FeedTab from './FeedTab'
import FeedList from './FeedList'
import BottomLoading from './components/BottomLoading'
const clientHeight =
  document.documentElement.clientHeight || document.body.clientHeight
const cacheData = {} // 缓存数据
export default {
  components: {
    FeedTab,
    FeedList,
    BottomLoading
  },
  props: {
    cmsPageId: {
      type: Number,
      default: 0
    },
    feedTabData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      currentTabIndex: 0, // 当前tab index
      feedList: [], // feed流推荐商品列表
      isLoading: false,
      isLastPage: false
    }
  },
  mounted() {
    // 获取第一个tab下的推荐数据
    if (this.feedTabData.data && this.feedTabData.data.length) {
      this.onTabChange({
        index: 0
      })
    }
    window.addEventListener('scroll', this.pageScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.pageScroll)
  },
  methods: {
    async pageScroll() {
      if (
        this.$refs.feedModule.getBoundingClientRect().bottom <=
        clientHeight + 40
      ) {
        const curTabData = this.feedTabData.data[this.currentTabIndex]
        // 如果不是最后一页 并且 没有正在加载数据
        if (
          cacheData[curTabData.active_id] &&
          !cacheData[curTabData.active_id].is_last_page &&
          !this.isLoading
        ) {
          this.isLoading = true
          await this.handleFeedData(curTabData)
          this.isLoading = false
        }
      }
    },
    // Feed Tab切换函数
    async onTabChange(data) {
      this.handleScrollIntoView(data.index)
      this.currentTabIndex = data.index
      const curTabData = this.feedTabData.data[this.currentTabIndex]
      // 埋点
      const tickerInfo = curTabData.tickerInfo
      const spm = tickerInfo.click.spm
      const Trackparams = Object.assign(
        tickerInfo.click.spmJson,
        tickerInfo.data
      )
      this.$track(spm, Trackparams)
      // 如果当前tab有缓存
      if (cacheData[curTabData.active_id]) {
        this.feedList = cacheData[curTabData.active_id].cacheList
      } else {
        this.feedList = []
        this.handleFeedData(curTabData)
      }
    },
    handleScrollIntoView(index) {
      if (this.currentTabIndex === index) return
      this.$refs.feedModule.scrollIntoView()
    },
    async handleFeedData(curTabData) {
      let page = 1
      // 如果当前tab有缓存并且有缓存page字段
      if (
        cacheData[curTabData.active_id] &&
        cacheData[curTabData.active_id].page
      ) {
        cacheData[curTabData.active_id].page++
        page = cacheData[curTabData.active_id].page
      }
      const feedData = await API.cms.getGoodsListByDataId({
        data_id: curTabData.active_id,
        data_source: curTabData.source,
        page,
        size: 20
      })
      this.feedList = [...this.feedList, ...feedData.list]
      this.isLastPage = feedData.is_last_page
      // 缓存当前请求到的tab对应feed商品列表
      Object.assign(cacheData, {
        [curTabData.active_id]: {
          page,
          is_last_page: feedData.is_last_page,
          cacheList: this.feedList
        }
      })
    },
    // 埋点同一处理
    onTick({ type }, { ssu, skuPos }) {
      const curTabData = this.feedTabData.data[this.currentTabIndex]
      const goodsTrackParams = {
        ssu_id: Number(ssu.ssu_id),
        ad_position: curTabData.tickerInfo.data.ad_position,
        cms_id: this.cmsPageId
      }
      switch (type) {
        case 'go-detail':
          this.$track(
            this.$trackMap.cmsModule.feedGoodsGoDetail,
            goodsTrackParams
          )
          break
        case 'add-goods':
          this.$track(this.$trackMap.cmsModule.feedAddGoods, goodsTrackParams)
          break
        case 'subscribe-goods':
          this.$track(
            this.$trackMap.cmsModule.feedSubscribeGoods,
            goodsTrackParams
          )
          break
        case 'go-pop':
          this.$track(
            this.$trackMap.cmsModule.feedGoPop,
            Object.assign({}, goodsTrackParams, {
              sku_id: ssu.sku_id || 0,
              pop_id: ssu.pop_id || 0,
              sku_pos: skuPos || 0
            })
          )
          break
      }
    }
  }
}
</script>
